module.exports = __webpack_public_path__ + "img/violet_109.22c05a7f.png";